import React, { useState, useEffect, useRef } from 'react';
import axios from './api/axiosConfig';
import CryptoJS from 'crypto-js';
import './styles/common.css';
import './App.css';

import { AUTH_API_URL, BASE_URL } from './api/config';
import { parseValidationError } from './utils/errorHandler';
const API_URL = AUTH_API_URL;
const COS_API_URL = `${BASE_URL}/api/cos/presigned-url`;

// SHA1 哈希函数
const sha1 = (message) => {
  return CryptoJS.SHA1(message).toString(CryptoJS.enc.Hex);
};

// SVG 图标组件
const Icons = {
  Close: () => (
    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
    </svg>
  ),
  Plus: () => (
    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 4v16m8-8H4" />
    </svg>
  ),
  Camera: () => (
    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 9a2 2 0 012-2h.93a2 2 0 001.664-.89l.812-1.22A2 2 0 0110.07 4h3.86a2 2 0 011.664.89l.812 1.22A2 2 0 0018.07 7H19a2 2 0 012 2v9a2 2 0 01-2 2H5a2 2 0 01-2-2V9z" />
      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 13a3 3 0 11-6 0 3 3 0 016 0z" />
    </svg>
  ),
  IdCardFront: () => (
    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M10 6H5a2 2 0 00-2 2v9a2 2 0 002 2h14a2 2 0 002-2V8a2 2 0 00-2-2h-5m-4 0V5a2 2 0 114 0v1m-4 0a2 2 0 104 0m-5 8a2 2 0 100-4 2 2 0 000 4zm0 0c1.306 0 2.417.835 2.83 2M9 14a3.001 3.001 0 00-2.83 2M15 11h3m-3 4h2" />
    </svg>
  ),
  IdCardBack: () => (
    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
    </svg>
  ),
  User: () => (
    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z" />
    </svg>
  ),
  Eye: () => (
    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z" />
    </svg>
  ),
  EyeOff: () => (
    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13.875 18.825A10.05 10.05 0 0112 19c-4.478 0-8.268-2.943-9.543-7a9.97 9.97 0 011.563-3.029m5.858.908a3 3 0 114.243 4.243M9.878 9.878l4.242 4.242M9.88 9.88l-3.29-3.29m7.532 7.532l3.29 3.29M3 3l3.59 3.59m0 0A9.953 9.953 0 0112 5c4.478 0 8.268 2.943 9.543 7a10.025 10.025 0 01-4.132 5.411m0 0L21 21" />
    </svg>
  ),
};

// 学历选项
const EDUCATION_OPTIONS = [
  { value: 1, label: '初中及以下' },
  { value: 2, label: '中专/中技' },
  { value: 3, label: '高中' },
  { value: 4, label: '大专' },
  { value: 5, label: '本科' },
  { value: 6, label: '硕士' },
  { value: 7, label: '博士' },
];

// 婚姻状况选项
const MARITAL_STATUS_OPTIONS = [
  { value: 1, label: '未婚' },
  { value: 2, label: '已婚' },
];

// 解析身份证 URL 数组
const parseIdCardUrls = (idcardUrl) => {
  if (!idcardUrl) return ['', ''];
  try {
    const urls = JSON.parse(idcardUrl);
    return Array.isArray(urls) ? [urls[0] || '', urls[1] || ''] : ['', ''];
  } catch (e) {
    return ['', ''];
  }
};

function UserProfilePage({ onClose }) {
  const [loading, setLoading] = useState(true);
  const [submitting, setSubmitting] = useState(false);
  const [uploadingAvatar, setUploadingAvatar] = useState(false);
  const [uploadingIdCard, setUploadingIdCard] = useState(null); // 'front' or 'back'
  const [formData, setFormData] = useState({
    id: null,
    nickname: '',
    real_name: '',
    phone: '',
    avatar_url: '',
    idcard_url: '',
    education: '',
    marital_status: '',
    id_card: '',
  });

  const [passwordData, setPasswordData] = useState({
    old_password: '',
    new_password: '',
    confirm_password: '',
  });
  const [showOldPassword, setShowOldPassword] = useState(false);
  const [showNewPassword, setShowNewPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const [changingPassword, setChangingPassword] = useState(false);
  const [originalData, setOriginalData] = useState(null);

  // 获取用户信息
  useEffect(() => {
    fetchUserInfo();
  }, []);

  const fetchUserInfo = async () => {
    try {
      const response = await axios.get(`${API_URL}/user-info`);
      if (response.data.success) {
        const data = response.data.data;
        setFormData({
          id: data.id,
          nickname: data.nickname,
          real_name: data.real_name || '',
          phone: data.phone || '',
          avatar_url: data.avatar_url || '',
          idcard_url: data.idcard_url || '',
          education: data.education?.toString() || '',
          marital_status: data.marital_status?.toString() || '',
          id_card: data.id_card || '',
        });
        setOriginalData(data);
      }
    } catch (error) {
      console.error('获取用户信息失败:', error);
      alert('获取用户信息失败：' + (error.response?.data?.message || error.message));
    } finally {
      setLoading(false);
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  // 上传头像
  const handleAvatarUpload = async (e) => {
    const files = Array.from(e.target.files);
    if (!files.length) return;

    const allowedTypes = ['image/png', 'image/jpeg', 'image/jpg'];
    for (const file of files) {
      if (!allowedTypes.includes(file.type)) {
        alert('只允许上传 PNG、JPG 或 JPEG 格式的图片');
        return;
      }
      if (file.size > 5 * 1024 * 1024) {
        alert('图片大小不能超过 5MB');
        return;
      }
    }

    setUploadingAvatar(true);

    try {
      // 获取用户信息
      const userInfo = JSON.parse(localStorage.getItem('userInfo') || '{}');
      let lastAccessUrl = '';

      // 逐个上传所有文件
      for (const file of files) {
        // 获取预签名上传 URL
        const presignedRes = await axios.get(`${COS_API_URL}/employee-head-image`, {
          params: {
            filename: file.name,
            content_type: file.type,
            user_id: userInfo.user_id,
            original_filename: file.name
          }
        });

        const { upload_url, access_url } = presignedRes.data;

        // 直接上传文件到 COS
        await axios.put(upload_url, file, {
          headers: {
            'Content-Type': file.type
          }
        });

        lastAccessUrl = access_url;
      }

      // 更新表单中的头像 URL（使用最后一张）
      setFormData(prev => ({ ...prev, avatar_url: lastAccessUrl }));
      alert('头像上传成功！');
    } catch (error) {
      console.error('上传头像失败:', error);
      alert('上传头像失败：' + parseValidationError(error));
    } finally {
      setUploadingAvatar(false);
    }
  };

  // 上传身份证
  const handleIdCardUpload = async (e, side) => {
    const file = e.target.files[0];
    if (!file) return;

    const allowedTypes = ['image/png', 'image/jpeg', 'image/jpg'];
    if (!allowedTypes.includes(file.type)) {
      alert('只允许上传 PNG、JPG 或 JPEG 格式的图片');
      return;
    }

    if (file.size > 5 * 1024 * 1024) {
      alert('图片大小不能超过 5MB');
      return;
    }

    setUploadingIdCard(side);

    try {
      // 文件名格式：姓名 +id+ 哪个面
      const fileName = `${formData.real_name}${formData.id}${side === 'front' ? '1' : '2'}.jpg`;

      // 获取预签名上传 URL
      const presignedRes = await axios.get(`${COS_API_URL}/employee-idcard`, {
        params: {
          folder: side === 'front' ? '人像面' : '国徽面',
          filename: fileName,
          content_type: file.type
        }
      });

      const { upload_url, access_url } = presignedRes.data;

      // 直接上传文件到 COS
      await axios.put(upload_url, file, {
        headers: {
          'Content-Type': file.type
        }
      });

      // 更新 idcard_url 状态
      setFormData(prev => {
        let urls = ['', ''];
        if (prev.idcard_url) {
          try {
            urls = JSON.parse(prev.idcard_url);
          } catch (e) {
            urls = ['', ''];
          }
        }
        if (side === 'front') {
          urls[0] = access_url;
        } else {
          urls[1] = access_url;
        }
        return { ...prev, idcard_url: JSON.stringify(urls) };
      });

      alert(`${side === 'front' ? '人像面' : '国徽面'}上传成功！`);
    } catch (error) {
      console.error('上传身份证失败:', error);
      alert(`上传${side === 'front' ? '人像面' : '国徽面'}失败：` + parseValidationError(error));
    } finally {
      setUploadingIdCard(null);
    }
  };

  // 保存用户信息
  const handleSubmit = async () => {
    setSubmitting(true);

    try {
      const updateData = {
        real_name: formData.real_name,
        phone: formData.phone,
        avatar_url: formData.avatar_url || null,
        idcard_url: formData.idcard_url || null,
        education: formData.education ? parseInt(formData.education) : null,
        marital_status: formData.marital_status ? parseInt(formData.marital_status) : null,
      };

      const response = await axios.put(`${API_URL}/user-info`, updateData);

      if (response.data.success) {
        alert('用户信息保存成功！');
        onClose();
      }
    } catch (error) {
      console.error('保存用户信息失败:', error);
      alert('保存失败：' + parseValidationError(error));
    } finally {
      setSubmitting(false);
    }
  };

  // 修改密码
  const handleChangePassword = async () => {
    const { old_password, new_password, confirm_password } = passwordData;

    if (!old_password) {
      alert('请输入原密码');
      return;
    }
    if (!new_password) {
      alert('请输入新密码');
      return;
    }
    if (new_password.length < 8) {
      alert('新密码长度需要 8 位以上');
      return;
    }
    if (!/[a-zA-Z]/.test(new_password) || !/\d/.test(new_password)) {
      alert('新密码需要数字和字母的组合');
      return;
    }
    if (new_password !== confirm_password) {
      alert('两次输入的新密码不一致');
      return;
    }

    setChangingPassword(true);
    try {
      const oldPasswordHash = sha1(old_password);
      const newPasswordHash = sha1(new_password);

      const response = await axios.post(`${API_URL}/change-password`, {
        old_password_hash: oldPasswordHash,
        new_password_hash: newPasswordHash,
      });

      if (response.data.success) {
        alert('密码修改成功！');
        setPasswordData({ old_password: '', new_password: '', confirm_password: '' });
      }
    } catch (error) {
      console.error('修改密码失败:', error);
      alert('修改密码失败：' + parseValidationError(error));
    } finally {
      setChangingPassword(false);
    }
  };

  if (loading) {
    return (
      <div className="user-profile-overlay">
        <div className="user-profile-modal">
          <div className="loading-state">加载中...</div>
        </div>
      </div>
    );
  }

  return (
    <div className="user-profile-overlay">
      <div className="user-profile-modal">
        {/* 头部 */}
        <div className="user-profile-header">
          <h2 className="user-profile-title">编辑个人资料</h2>
          <button className="user-profile-close" onClick={onClose}>
            <Icons.Close />
          </button>
        </div>

        {/* 身体内容 */}
        <div className="user-profile-body">
          {/* 卡片形象 */}
          <div className="profile-section">
            <div className="profile-section-title">卡片形象</div>

            {/* 头像上传按钮 */}
            <div className="avatar-upload-container">
              <label htmlFor="avatar-upload" className="avatar-upload-btn">
                {formData.avatar_url ? (
                  <img src={formData.avatar_url} alt="头像" className="avatar-preview" />
                ) : (
                  <div className="avatar-placeholder">
                    <Icons.Plus />
                  </div>
                )}
              </label>
              <input
                type="file"
                id="avatar-upload"
                accept="image/png, image/jpeg, image/jpg"
                multiple
                onChange={handleAvatarUpload}
                style={{ display: 'none' }}
                disabled={uploadingAvatar}
              />
              {uploadingAvatar && <div className="uploading-hint">上传中...</div>}
            </div>
          </div>

          {/* 姓名 */}
          <div className="profile-section">
            <div className="profile-label">姓名</div>
            <input
              type="text"
              name="real_name"
              value={formData.real_name}
              onChange={handleChange}
              className="profile-input"
              placeholder="请输入姓名"
            />
          </div>

          {/* 最高学历 */}
          <div className="profile-section">
            <div className="profile-label">最高学历</div>
            <select
              name="education"
              value={formData.education}
              onChange={handleChange}
              className="profile-select"
            >
              <option value="">请选择学历</option>
              {EDUCATION_OPTIONS.map(opt => (
                <option key={opt.value} value={opt.value}>{opt.label}</option>
              ))}
            </select>
          </div>

          {/* 身份证信息 */}
          <div className="profile-section">
            <div className="profile-label">身份证信息</div>
            <div className="idcard-upload-container">
              {/* 人像面 */}
              {(() => {
                const [frontUrl, backUrl] = parseIdCardUrls(formData.idcard_url);
                return (
                  <>
                    <label htmlFor="idcard-front-upload" className="idcard-upload-btn">
                      {frontUrl ? (
                        <img src={frontUrl} alt="身份证人像面" className="idcard-preview" />
                      ) : (
                        <>
                          <div className="idcard-icon">
                            <Icons.IdCardFront />
                          </div>
                          <span className="idcard-label">上传人像面</span>
                        </>
                      )}
                    </label>
                    <input
                      type="file"
                      id="idcard-front-upload"
                      accept="image/png, image/jpeg, image/jpg"
                      multiple
                      onChange={(e) => handleIdCardUpload(e, 'front')}
                      style={{ display: 'none' }}
                      disabled={uploadingIdCard === 'front'}
                    />

                    {/* 国徽面 */}
                    <label htmlFor="idcard-back-upload" className="idcard-upload-btn">
                      {backUrl ? (
                        <img src={backUrl} alt="身份证国徽面" className="idcard-preview" />
                      ) : (
                        <>
                          <div className="idcard-icon">
                            <Icons.IdCardBack />
                          </div>
                          <span className="idcard-label">上传国徽面</span>
                        </>
                      )}
                    </label>
                    <input
                      type="file"
                      id="idcard-back-upload"
                      accept="image/png, image/jpeg, image/jpg"
                      multiple
                      onChange={(e) => handleIdCardUpload(e, 'back')}
                      style={{ display: 'none' }}
                      disabled={uploadingIdCard === 'back'}
                    />
                  </>
                );
              })()}
            </div>
            {uploadingIdCard && <div className="uploading-hint">上传中...</div>}
          </div>

          {/* 手机号码 */}
          <div className="profile-section">
            <div className="profile-label">手机号码</div>
            <input
              type="tel"
              name="phone"
              value={formData.phone}
              onChange={handleChange}
              className="profile-input"
              placeholder="请输入手机号码"
              maxLength="11"
            />
          </div>

          {/* 婚姻状况 */}
          <div className="profile-section">
            <div className="profile-label">婚姻状况</div>
            <select
              name="marital_status"
              value={formData.marital_status}
              onChange={handleChange}
              className="profile-select"
            >
              <option value="">请选择婚姻状况</option>
              {MARITAL_STATUS_OPTIONS.map(opt => (
                <option key={opt.value} value={opt.value}>{opt.label}</option>
              ))}
            </select>
          </div>

          {/* 修改密码 */}
          <div className="profile-section">
            <div className="profile-section-title">修改密码</div>

            <div className="profile-label">原密码</div>
            <div className="password-input-wrapper">
              <input
                type={showOldPassword ? 'text' : 'password'}
                value={passwordData.old_password}
                onChange={(e) => setPasswordData(prev => ({ ...prev, old_password: e.target.value }))}
                className="profile-input"
                placeholder="请输入原密码"
              />
              <button
                type="button"
                className="password-toggle"
                onClick={() => setShowOldPassword(!showOldPassword)}
              >
                {showOldPassword ? <Icons.EyeOff /> : <Icons.Eye />}
              </button>
            </div>

            <div className="profile-label" style={{ marginTop: '12px' }}>新密码</div>
            <div className="password-input-wrapper">
              <input
                type={showNewPassword ? 'text' : 'password'}
                value={passwordData.new_password}
                onChange={(e) => setPasswordData(prev => ({ ...prev, new_password: e.target.value }))}
                className="profile-input"
                placeholder="8位以上，数字和字母组合"
              />
              <button
                type="button"
                className="password-toggle"
                onClick={() => setShowNewPassword(!showNewPassword)}
              >
                {showNewPassword ? <Icons.EyeOff /> : <Icons.Eye />}
              </button>
            </div>

            <div className="profile-label" style={{ marginTop: '12px' }}>确认新密码</div>
            <div className="password-input-wrapper">
              <input
                type={showConfirmPassword ? 'text' : 'password'}
                value={passwordData.confirm_password}
                onChange={(e) => setPasswordData(prev => ({ ...prev, confirm_password: e.target.value }))}
                className="profile-input"
                placeholder="请再次输入新密码"
              />
              <button
                type="button"
                className="password-toggle"
                onClick={() => setShowConfirmPassword(!showConfirmPassword)}
              >
                {showConfirmPassword ? <Icons.EyeOff /> : <Icons.Eye />}
              </button>
            </div>

            <button
              className="btn-change-password"
              onClick={handleChangePassword}
              disabled={changingPassword}
            >
              {changingPassword ? '修改中...' : '修改密码'}
            </button>
          </div>
        </div>

        {/* 底部按钮 */}
        <div className="user-profile-footer">
          <button className="btn-profile-cancel" onClick={onClose}>
            取消
          </button>
          <button
            className="btn-profile-save"
            onClick={handleSubmit}
            disabled={submitting}
          >
            {submitting ? '保存中...' : '保存'}
          </button>
        </div>
      </div>
    </div>
  );
}

export default UserProfilePage;
